export const config = {
  title: 'Cynthia Thomas | Coldwell Banker Bullard Realty | McDonough, GA',
  meta: {
    description:
      'Cynthia Thomas of Coldwell Banker Bullard Realty offers expert real estate services in McDonough, GA. Whether buying or selling, trust Cynthia for a seamless experience.',
    keywords: [
      'Cynthia Thomas',
      'Coldwell Banker Bullard Realty',
      'McDonough Real Estate',
      'Georgia Homes',
      'Real Estate Agent',
      'Home Buying',
      'Home Selling',
      'Property Listings',
    ],
    author: 'Cynthia Thomas',
    canonicalUrl: 'https://www.cynthiathomasrealty.com/',
  },
  sections: {
    header: {
      businessName: 'Cynthia Thomas',
    },
    sectionB: {
      heroTitle: 'Your Trusted Real Estate Partner',
      heroSubtitle: 'Expert Guidance in McDonough, GA',
      learnAboutText: 'Discover More',
      phoneNumber: '2296332521',
      phoneLabel: '(229) 633-2521',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/2150256335/photo/aerial-view-directly-above-established-houses-in-older-adelaide-southern-suburb.jpg?s=612x612&w=0&k=20&c=LYtAvxAeSSy_fRafrWMQEGSG3UebABWrxuB_mcatOQw=',
      cardData: [
        {
          title: 'Buying a Home',
          description:
            'Navigate the home buying process with confidence, guided by Cynthia’s expertise.',
        },
        {
          title: 'Selling Your Property',
          description:
            'Achieve optimal results with strategic marketing and dedicated support.',
        },
        {
          title: 'Market Insights',
          description:
            'Stay informed with the latest market trends and property evaluations.',
        },
      ],
      description:
        'With in-depth knowledge of McDonough and surrounding areas, Cynthia Thomas provides personalized real estate services to meet your unique needs.',
    },
    sectionC: {
      servicesTitle: 'Real Estate Services',
      servicesDescription:
        'Comprehensive services tailored to buyers, sellers, and investors in McDonough, GA.',
      cards: [
        {
          title: 'Home Buying Assistance',
          description:
            'From property searches to closing deals, receive end-to-end support.',
          imageSrc: 'https://media.istockphoto.com/id/998987128/photo/business-man-hand-hold-the-house-model-saving-small-house.jpg?s=612x612&w=0&k=20&c=rVq_U_j2tsvnC3GlvW2Hn0yRVRu3aAGIN18Q3GCr868=',
          imageAlt: 'Home Buying',
        },
        {
          title: 'Home Selling Strategies',
          description:
            'Maximize your property’s value with effective marketing and negotiation.',
          imageSrc: 'https://media.istockphoto.com/id/2154752387/photo/real-estate-concept-business-home-insurance-and-real-estate-protection-real-estate-investment.jpg?s=612x612&w=0&k=20&c=r6Tmn31ZHHr-8ZuWfZaYIYdqM9nD4dMc6NfDXxwsZeo=',
          imageAlt: 'Home Selling',
        },
        {
          title: 'Investment Opportunities',
          description:
            'Explore lucrative real estate investments with professional guidance.',
          imageSrc: 'https://media.istockphoto.com/id/1409892847/photo/businessman-analyzing-digital-financial-balance-sheet-of-company-working-with-digital-virtual.jpg?s=612x612&w=0&k=20&c=eBiGxbiNCKlLwvaH-4uUUibssXW_4UfoeHXxnzRgo_U=',
          imageAlt: 'Real Estate Investment',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Property Valuation',
        'Market Analysis',
        'Relocation Assistance',
        'First-Time Homebuyer Programs',
        'Open House Coordination',
      ],
    },
    sectionD: {
      aboutTitle: 'About Cynthia',
      aboutImage: {
        src: 'https://images.marketleader.com/MarketingImages/36/2404836_normal.JPG',
        alt: 'Cynthia Thomas',
      },
      aboutText: [
        'As a dedicated real estate professional, Cynthia Thomas brings a wealth of knowledge and a commitment to excellence in every transaction.',
        'Her personalized approach ensures that each client’s unique goals are met with integrity and professionalism.',
      ],
    },
    sectionE: {
      profileImage: null, // Add profile image URL if available
      profileAlt: 'Cynthia Thomas',
      businessName: 'Cynthia Thomas',
      contact: {
        phone: '2296332521',
        phoneLabel: '(229) 633-2521',
        email: 'Cthomas@Cbbullard.com',
        website: 'https://www.cynthiathomasrealty.com/',
        address: '4295 Jodeco Road, McDonough, GA 30253, USA',
      },
      socialMedia: {
        facebook: null, 
        instagram: null,
        twitter: null,
        linkedIn: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '4295 Jodeco Road, McDonough, GA 30253, USA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3311.123456789!2d-84.1234567!3d33.1234567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f3e123456789ab%3A0x123456789abcdef!2s4295%20Jodeco%20Rd%2C%20McDonough%2C%20GA%2030253%2C%20USA!5e0!3m2!1sen!2sus!4v1611234567890!5m2!1sen!2sus',
    },
  },
};

export default config;
